function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M109.297 15.951c.3 3.586-1.426 9.31-.734 13.654.77 4.83 3.222 6.828 5.297 7.644l-.003-.003-.77 2.674-.745 4.388 8.184 2.443 6.61-1.414-.435-7.618s6.016-3.078 6.684-10.92c1.875.344 3.962-1.289 4.788-3.831.878-2.7.003-5.408-1.958-6.045-1.962-.637-4.3.637-5.642 2.94l-4.507-12.265-12.876 1.047-3.893 7.306z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB27D",
  d: "m109.236 15.524 11.359-4.821 6.956-.375 2.492 7.265 4.332-1.003 4.14.508v2.966l-.502 3.767-2.123 2.178-2.505.79-.057 1.772-1.528 3.688-2.753 3.497-2.346 2.05.434 7.436-3.26 2.266-9.412-4.021-1.375-3.564.77-2.118-1.894-1.566-2.076-2.7-1.49-5.528 1.49-10.418z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.46 20.064c-.209-1.52-1.011-2.74-2.245-3.138-1.962-.637-4.3.637-5.642 2.94 0 0-4.528-2.733-5.432-9.917 0 0-7.864 6.771-15.841 6.002-6.283-.607-6.708-12.409-6.708-12.409S113.1-3.579 124.883 1.09c0 0 5.603-2.444 11.565 3.31 6.732 6.497 2.013 15.664 2.013 15.664z",
  fill: "#1E1E1E",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.297 15.951c.3 3.586-1.426 9.31-.734 13.654 1.41 8.862 8.493 8.189 8.493 8.189M133.385 26.8c-.67 7.841-6.684 10.919-6.684 10.919",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.777 25.878c.344.386.766.673 1.258.832 1.961.637 4.26-1.038 5.141-3.742.878-2.7.003-5.408-1.958-6.045-1.962-.637-4.3.637-5.642 2.94 0 0-4.528-2.733-5.432-9.917 0 0-7.864 6.771-15.841 6.002-6.283-.607-6.708-12.409-6.708-12.409s10.508-7.121 22.291-2.452c0 0 5.603-2.444 11.565 3.31 6.738 6.5 2.016 15.67 2.016 15.67",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.328 19.854c1.749-.822 2.743.84 2.13 2.327M126.857 40.465l.278 4.875M113.858 37.249l-.77 2.674",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.03 195.5s65.88-15.475 65.88-75.173V51.2A131.133 131.133 0 0 1 92.14 28.01C73.05 41.909 50.077 50.807 25.15 52.775v67.55c0 59.703 65.88 75.175 65.88 75.175z",
  fill: "#2B9D8B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.123 64.951v54.395c0 19.546 8.902 35.58 26.46 47.657 9.498 6.535 19.078 10.214 24.447 11.945 5.5-1.773 15.323-5.557 24.995-12.325 17.195-12.035 25.912-27.94 25.912-47.277V63.372a145.622 145.622 0 0 1-49.61-18.43C76.282 54.967 58.743 61.691 40.123 64.951z",
  fill: "#E0F4E9",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E15D29",
  fillRule: "nonzero",
  d: "m84.059 140.124-26.712-26.676 10.164-10.15 16.548 16.524 36.48-36.435 10.163 10.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.79 124.676a79.55 79.55 0 0 0 .12-4.349V51.2M25.15 95.234v24.01M25.15 52.778v10.127M74.177 39.008a131.108 131.108 0 0 1-49.027 13.77M92.14 28.01a131.494 131.494 0 0 1-7.336 4.974",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.043 46.234a131.322 131.322 0 0 1-37.905-18.223",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m86.523 37.656-2.144-5.554a1.515 1.515 0 0 0-2.063-.822 1.51 1.51 0 0 0-.725 1.998l.018.074a1.71 1.71 0 0 0-2.985 1.657l-.018-.02a1.543 1.543 0 0 0-2.186-.548 1.537 1.537 0 0 0-.47 2.112l.09.14c-.47-.75-1.501-.906-2.172-.326-.578.5-.665 1.36-.2 1.968l3 3.924a1.215 1.215 0 0 0 1.994-1.382l.399.637a1.39 1.39 0 0 0 2.392-1.408l.557 1.002a1.454 1.454 0 0 0 2.59-1.31l-.514-1.113c.332.724 1.227.99 1.904.568a1.316 1.316 0 0 0 .533-1.597z",
  fill: "#FFB27D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.208 41.858a1.45 1.45 0 0 1-1.2-.744l-3.346-6.021a1.709 1.709 0 0 1 .713-2.35h0a1.712 1.712 0 0 1 2.339.804l2.518 5.461",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.606 34.988a1.543 1.543 0 0 0-2.186-.547h0a1.537 1.537 0 0 0-.47 2.112M74.79 39.81l-1.125-1.472a1.445 1.445 0 0 1 .2-1.968h0c.67-.58 1.701-.425 2.171.326l2.156 3.44M81.591 33.28a1.51 1.51 0 0 1 .725-1.997h0c.796-.38 1.746 0 2.063.822l.925 2.402",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M144.195 46.886a1.443 1.443 0 0 0-1.943 1.017l.036-.162a1.54 1.54 0 0 0-1.138-1.842 1.541 1.541 0 0 0-1.887 1.232l-.009.027a1.712 1.712 0 0 0-3.369-.577l-.006-.087a1.51 1.51 0 0 0-1.341-1.65 1.512 1.512 0 0 0-1.68 1.45l-.204 5.946a1.326 1.326 0 0 0 2.644.176l-.12 1.22a1.453 1.453 0 0 0 2.878.392l.198-1.13a1.389 1.389 0 0 0 2.722.55l.168-.733c-.15.65.254 1.298.904 1.45a1.217 1.217 0 0 0 1.432-.798l1.55-4.69a1.448 1.448 0 0 0-.835-1.791z",
  fill: "#FFB27D",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "m138.251 52.9.991-5.652a1.712 1.712 0 0 0-1.443-1.989h0a1.713 1.713 0 0 0-1.947 1.525l-.598 6.09M139.263 47.131a1.543 1.543 0 0 1 1.887-1.232h0a1.54 1.54 0 0 1 1.138 1.842l-1.312 5.707M144.3 50.885l.73-2.204a1.44 1.44 0 0 0-.835-1.792h0a1.443 1.443 0 0 0-1.943 1.017",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.882 46.491a1.51 1.51 0 0 0-1.341-1.65h0a1.512 1.512 0 0 0-1.68 1.45",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40.123 64.951v54.395c0 19.546 8.902 35.58 26.46 47.657 9.498 6.535 19.078 10.214 24.447 11.945m50.907-99.025V63.372a145.622 145.622 0 0 1-49.61-18.43m-1.297 134.01a98.813 98.813 0 0 0 15.724-6.667M130.702 93.538l-46.643 46.586-16.285-16.265",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.348 182.448C76.662 192.123 91.03 195.5 91.03 195.5s46.011-10.806 61.128-49.2M45.435 169.787a85.797 85.797 0 0 0 9.505 8.252M64.588 120.68l-4.546-4.54",
  stroke: "#1E1E1E",
  strokeWidth: 1.198,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 135)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.268 62.5 19.95 44.502a3.801 3.801 0 0 1-.462-5.331L47.043 6.126a3.745 3.745 0 0 1 5.298-.465L73.657 23.66a3.801 3.801 0 0 1 .463 5.331L46.566 62.035a3.745 3.745 0 0 1-5.298.466z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.486 21.034c1.207-.53 1.884-1.116 1.884-1.737V9.335L19.489 39.174a3.801 3.801 0 0 0 .462 5.33l21.317 18c.372.314.79.541 1.225.689V21.034h-.007z",
  fill: "#CCE6D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 62.234,
  cy: 27.353,
  rx: 4.888,
  ry: 4.919
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 41.042,
  cy: 29.218,
  rx: 4.888,
  ry: 4.919
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.423 42.715a4.936 4.936 0 0 1-.601-6.928 4.863 4.863 0 0 1 6.884-.605 4.936 4.936 0 0 1 .602 6.928 4.864 4.864 0 0 1-3.745 1.755",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 31.375,
  cy: 40.812,
  rx: 4.888,
  ry: 4.919
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 42.896,
  cy: 50.54,
  rx: 4.888,
  ry: 4.919
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M69.92 34.028 46.566 62.035M34.026 56.39 19.95 44.505a3.801 3.801 0 0 1-.462-5.331L47.043 6.13a3.745 3.745 0 0 1 5.298-.466l21.316 18a3.801 3.801 0 0 1 .463 5.331M46.566 62.035a3.745 3.745 0 0 1-5.298.466"
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 50.709,
  cy: 17.625,
  rx: 4.888,
  ry: 4.919
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.68 0C9.258 0 0 1.862 0 4.162v15.135c0 .62.677 1.207 1.884 1.737H1.88v45.182C1.88 68.305 10.3 70 20.68 70c10.383 0 18.801-1.695 18.801-3.784V21.034h-.003c1.207-.53 1.884-1.116 1.884-1.737V4.162C41.362 1.862 32.104 0 20.68 0z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.481 22.926c-3.27 1.43-10.456 2.425-18.8 2.425-8.344 0-15.533-.995-18.8-2.425V19.44h37.6v3.485zM20.68 30.27c-10.381 0-18.8-1.695-18.8-3.784v30.65c0 2.088 8.419 3.783 18.8 3.783.719 0 1.426-.008 2.121-.023V30.248c-.695.01-1.402.022-2.12.022z",
  fill: "#CCE6D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.92 42.303a74.94 74.94 0 0 1-6.392-.522v-6.433c-2.662-.344-4.861-.821-6.38-1.381v6.432c-1.444-.537-2.268-1.15-2.268-1.8v6.432c0 .65.824 1.267 2.267 1.8v6.433c1.516.56 3.72 1.037 6.381 1.381v-6.432c1.922.25 4.08.428 6.393.522v-6.432zM20.68 0C9.258 0 0 1.862 0 4.162v15.135c0 2.3 9.257 4.162 20.68 4.162 11.424 0 20.682-1.861 20.682-4.162V4.162C41.362 1.862 32.104 0 20.68 0z",
  fill: "#E15D29",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M39.481 57.389V21.034M1.88 21.034v45.182C1.88 68.305 10.3 70 20.68 70c9.085 0 16.666-1.298 18.418-3.02M36.962 1.597c2.756.707 4.4 1.597 4.4 2.565M41.362 4.162c0 2.3-9.258 4.162-20.681 4.162C9.257 8.324 0 6.463 0 4.162 0 1.862 9.257 0 20.68 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.362 4.162v15.135c0 2.3-9.258 4.162-20.681 4.162C9.257 23.46 0 21.598 0 19.297V4.162M8.81 29.419c3.237.53 7.37.851 11.87.851 1.324 0 2.614-.026 3.859-.08 2.132-.09 3.903 1.635 3.903 3.78v23.074c0 2.017-1.572 3.69-3.572 3.78-1.347.06-2.75.095-4.19.095-10.381 0-18.8-1.695-18.8-3.784M22.805 30.248v24.019",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.528 54.645v-6.432c1.922.25 4.08.428 6.393.522v-6.432a74.94 74.94 0 0 1-6.393-.522v-6.433c-2.662-.344-4.861-.821-6.38-1.381",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.21 59.42h-5.617c.402.084.722 1.741.722 3.777 0 2.035-.32 3.693-.722 3.776h5.618c2.072 0 3.752-1.691 3.752-3.776s-1.677-3.776-3.752-3.776z",
  fill: "#E15D29",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.315 63.197c0-2.036-.32-3.693-.722-3.776h-4.926c-2.072 0-3.752 1.69-3.752 3.776 0 2.085 1.68 3.776 3.752 3.776h4.926c.402-.083.722-1.74.722-3.776z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.21 66.973H47.668c-2.072 0-3.752-1.691-3.752-3.776h0c0-2.085 1.68-3.776 3.752-3.776h10.544c2.072 0 3.752 1.69 3.752 3.776h0c0 2.085-1.677 3.776-3.752 3.776z",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.563 59.413c.414 0 .752 1.695.752 3.784 0 2.088-.338 3.784-.752 3.784",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.492 60.525 67.52 56.53c.225.344-.71 1.744-2.143 3.182-1.433 1.442-2.82 2.384-3.163 2.157l3.971 3.995a3.733 3.733 0 0 0 5.306 0 3.79 3.79 0 0 0 0-5.339z",
  fill: "#E15D29",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.378 59.712c1.432-1.442 2.368-2.838 2.143-3.182l-3.486-3.508a3.733 3.733 0 0 0-5.305 0 3.79 3.79 0 0 0 0 5.34l3.485 3.507c.342.227 1.73-.715 3.163-2.157z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "m66.186 65.868-7.456-7.503a3.79 3.79 0 0 1 0-5.34h0a3.733 3.733 0 0 1 5.305 0l7.457 7.504a3.79 3.79 0 0 1 0 5.34h0a3.74 3.74 0 0 1-5.306 0z",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.506 56.503c.293.295-.658 1.733-2.128 3.213-1.47 1.48-2.896 2.436-3.193 2.141",
  stroke: "#1E1E1E",
  strokeWidth: 1.505,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeWidth: 1.291,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m147.5 204.5-111.716.34"
}));

function SvgProviderDone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 205,
    viewBox: "0 0 183 205",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderDone);
export default __webpack_public_path__ + "static/media/provider_done.53c60a65.svg";
export { ForwardRef as ReactComponent };